import { render, staticRenderFns } from "./aimap.vue?vue&type=template&id=7a4b64c2&scoped=true"
import script from "./aimap.vue?vue&type=script&lang=js"
export * from "./aimap.vue?vue&type=script&lang=js"
import style0 from "./aimap.vue?vue&type=style&index=0&id=7a4b64c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b64c2",
  null
  
)

export default component.exports